import type { ViewAllNotesEntryView } from "@credit-acceptance/step6-bff-client";

/**
 * A single View All Notes row, normalized for the UI.
 *
 * The generated `ViewAllNotesEntryView` types every field as optional
 * (`?: string`) because the BFF forwards recap-service payloads verbatim. The
 * table renders verbatim values, so we keep the string fields but coerce the
 * absent case to an empty string at the mapping boundary (see
 * {@link toViewAllNotesEntry}) — that keeps the render path free of `?? ""`
 * noise.
 */
export interface ViewAllNotesEntry {
  /** Raw date/time the note was recorded in recap. */
  entryDate: string;
  /** The note content. */
  notes: string;
  /** User who recorded the note. */
  user: string;
}

/**
 * Normalizes a raw `ViewAllNotesEntryView` into a {@link ViewAllNotesEntry},
 * coercing the string columns' absent case to `""` so the table renders a
 * blank cell rather than "undefined".
 * @param {ViewAllNotesEntryView} raw - A single note row from the BFF.
 * @returns {ViewAllNotesEntry} The normalized entry.
 */
export function toViewAllNotesEntry(raw: ViewAllNotesEntryView): ViewAllNotesEntry {
  return {
    entryDate: raw.entryDate ?? "",
    notes: raw.notes ?? "",
    user: raw.user ?? "",
  };
}
